import { useState, createContext, useEffect, useMemo } from "react"
import { IntlProvider } from "react-intl"

import { Turkish } from 'flatpickr/dist/l10n/tr'
import { english } from 'flatpickr/dist/l10n/default'

import tr from "components/translate/tr.json"
import en from "components/translate/en.json"

import * as Redux from "utils/redux-store"
import {handleSwitchLanguage} from "utils/redux-store"

import moment from "moment"
import "moment/locale/tr"
import "moment/locale/en-gb"

import PropTypes from "prop-types"

export const IntlContext = createContext()

export function IntlContextProvider({children, initialLanguage = null}) {

    console.log("initialLanguage-->", initialLanguage)

    const storedLanguage = localStorage.getItem("language");

    const initialLangCode = initialLanguage ?? storedLanguage ?? "tr";
    const initialLangKey = localStorage.getItem("languageId") ?? -1;

    const [langKey, setLangKey] = useState(initialLangKey);
    const [language, setLanguage] = useState(initialLangCode);

    const supportedLocales = {
        en: en,
        tr: tr,
    };

    useEffect(() => {
        const momentLocale = language === "tr" ? "tr" : "en-gb";
        moment.locale(momentLocale);
    }, [language]);

    const contextValue = useMemo(() => ({
        language,
        flatpickrLocale: language === "en" ? english : Turkish,
        switchLanguage: (lang) => {
            const langCode = lang.code;
            const langId = lang.id;

            moment.locale(langCode === "tr" ? "tr" : "en-gb");

            localStorage.setItem("language", langCode);
            localStorage.setItem("languageId", langId);

            Redux.setLanguageId(langId);
            Redux.setLanguage(langCode);

            setLanguage(langCode);
            setLangKey(langId);

            handleSwitchLanguage(langId);
        }
    }), [language]);

    return (
        <IntlContext.Provider value={contextValue}>
            <IntlProvider
                key={langKey}
                locale={language}
                messages={supportedLocales[language] || tr}
                defaultLocale="tr">
                    {children}
                </IntlProvider>
        </IntlContext.Provider>
    )
}

IntlContextProvider.propTypes = {
    children: PropTypes.node,
    initialLanguage: PropTypes.string
}